import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, A11y, Thumbs } from "swiper/modules";

export default {
    name: 'slider',
    component() {
        return {
            initSlider() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 8,
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 16,
                        },
                        1000: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                        },
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderCollections() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 2,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 8,
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 16,
                        },
                        1000: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                            navigation: {
                                nextEl: this.$root
                                    .querySelector("[data-slider-btn-next]"),
                                prevEl: this.$root
                                    .querySelector("[data-slider-btn-prev]"),
                            },
                        },
                    },
                });
            },

            initSliderBlogs() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, Pagination, A11y, Navigation],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 8,
                    pagination: {
                        el: this.$root
                            .querySelector("[data-slider-pagination]"),
                    },
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                            pagination: {
                                el: this.$root
                                    .querySelector("[data-slider-pagination]"),
                            },
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 16,
                            pagination: {
                                el: this.$root
                                    .querySelector("[data-slider-pagination]"),
                            },
                        },
                        1000: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        },
                    },
                    // navigation: {
                    //     nextEl: this.$root
                    //         .querySelector("[data-slider-btn-next]"),
                    //     prevEl: this.$root
                    //         .querySelector("[data-slider-btn-prev]"),
                    // },
                });
            },

            initSliderHeaderList() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    speed: 5000,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 8,
                    breakpoints: {
                        480: {
                            slidesPerView: 1.5,
                            spaceBetween: 8,
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 16,
                        },
                        1000: {
                            slidesPerView: 3,
                            spaceBetween: 16,
                        },

                        1200: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                        },
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderProduct() {
                const slider = this.$root.querySelector(".swiper");
                const sliderThumbs = this.$root.querySelector(".swiper-thumbs");

                let thumbSlider = new Swiper(sliderThumbs, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "vertical",
                    loop: false,
                    slidesPerView: "auto",
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 8,
                    // navigation: {
                    //     nextEl: this.$root
                    //         .querySelector("[data-slider-btn-next]"),
                    //     prevEl: this.$root
                    //         .querySelector("[data-slider-btn-prev]"),
                    // },
                });

                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation, Thumbs],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 8,
                    thumbs: {
                        swiper: thumbSlider,
                        autoScrollOffset: 1,
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderTestimonials() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation, Pagination],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 1.3,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 8,
                    pagination: {
                        el: this.$root
                            .querySelector("[data-slider-pagination]"),
                    },
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                            pagination: {
                                el: this.$root
                                    .querySelector("[data-slider-pagination]"),
                            },
                        },
                        1000: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                            navigation: {
                                nextEl: this.$root
                                    .querySelector("[data-slider-btn-next]"),
                                prevEl: this.$root
                                    .querySelector("[data-slider-btn-prev]"),
                            },
                        },
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                            navigation: {
                                nextEl: this.$root
                                    .querySelector("[data-slider-btn-next]"),
                                prevEl: this.$root
                                    .querySelector("[data-slider-btn-prev]"),
                            },
                        },
                    },
                });
            },

            initSliderComplementary() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: false,
                    slidesPerView: 2,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 8,
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 8,
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 16,
                        },
                        1000: {
                            slidesPerView: 4,
                            spaceBetween: 24,
                        },
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },
        }
    }
}